var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0.0625C3.16846 0.0625 2.1875 1.04346 2.1875 2.25C2.1875 3.45654 3.16846 4.4375 4.375 4.4375C5.58154 4.4375 6.5625 3.45654 6.5625 2.25C6.5625 1.04346 5.58154 0.0625 4.375 0.0625ZM4.375 4.4375C2.20459 4.4375 0.4375 6.20288 0.4375 8.375H8.3125C8.3125 7.94604 8.23389 7.53076 8.10742 7.14453C8.15186 7.04712 8.19971 6.94971 8.25781 6.85742C8.68506 6.18921 9.42676 5.75 10.2812 5.75C11.616 5.75 12.6875 6.82153 12.6875 8.15625V8.375H13.5625V8.15625C13.5625 6.88647 12.8328 5.77563 11.7715 5.23047C12.3286 4.78955 12.6875 4.10596 12.6875 3.34375C12.6875 2.01929 11.6057 0.9375 10.2812 0.9375C8.95679 0.9375 7.875 2.01929 7.875 3.34375C7.875 4.11279 8.23901 4.80322 8.80469 5.24414C8.35181 5.47485 7.95874 5.79614 7.65625 6.20117C6.95044 5.13989 5.74219 4.4375 4.375 4.4375ZM10.2812 1.8125C11.1323 1.8125 11.8125 2.49268 11.8125 3.34375C11.8125 4.19482 11.1323 4.875 10.2812 4.875C9.43018 4.875 8.75 4.19482 8.75 3.34375C8.75 2.49268 9.43018 1.8125 10.2812 1.8125Z",
    fill: "#84818A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.a02f2e0f922c66924cee2250164d2b33.svg";
export { ForwardRef as ReactComponent };